<template>
    <div class="absolute w-full h-full"  @click="delay===0 ? hide() : false" v-show="show" >
        <component :title="title" :is="component"></component>
    </div>
</template>

<script>

    import Counting from "./Counting";
    export default {
        name: 'hider',
        components:{
          Counting
        },
        props:{
            'title':{
                type:String,
                required:true
            },
            'delay':{
                type:Number,
                default:0
            },
            'component':{
                type:String,
                required:true
            }
        },
        data() {
            return {
                show:true
            }

        },
        computed: {},
        methods: {
            hide(){
                this.show=false;
            }
        },
        mounted() {
            if(this.delay>0){
                setTimeout(this.hide,this.delay);
            }
        }
    }
</script>
